<template>
  <div :id="componentId" class="spm1-orgs" :style="{ backgroundImage: `url(${backgroundImage})` }">
    <div class="spm1-org-list">
      <a
        v-for="(item, idx) in items"
        :key="idx"
        :class="['spm1-org-item', { 'is-link': item.jumpType === 2 }]"
        href="javascript:;"
        @click.prevent="handleClick(item)"
      >
        <img class="spm1-org-image" referrerpolicy="no-referrer" :src="item.imageUrl" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileOrganizations',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_13'
    }
  },
  data() {
    return {
      backgroundImage: require('../../../special/SpecialOne/assets/img/bottom_bg.png'),
      items: [
        { imageUrl: require('../../../special/SpecialOne/assets/img/organizations_card.png'), jumpType: 1, linkAddress: '' },
        { imageUrl: require('../../../special/SpecialOne/assets/img/organizations_card.png'), jumpType: 2, linkAddress: 'https://www.example.com/org/2' },
        { imageUrl: require('../../../special/SpecialOne/assets/img/organizations_card.png'), jumpType: 1, linkAddress: '' },
        { imageUrl: require('../../../special/SpecialOne/assets/img/organizations_card.png'), jumpType: 2, linkAddress: 'https://www.example.com/org/4' }
      ]
    }
  },
  methods: {
    handleClick(item) {
      if (item.jumpType !== 2 || !item.linkAddress) return
      window.open(item.linkAddress, '_blank')
    }
  }
}
</script>

<style scoped>
.spm1-orgs {
  width: 100%;
  padding: 16px 12px;
  box-sizing: border-box;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.spm1-org-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.spm1-org-item {
  display: block;
  width: 100%;
  border-radius: 6px;
  overflow: hidden;
}

.spm1-org-item.is-link {
  cursor: pointer;
}

.spm1-org-item.is-link:active {
  opacity: 0.9;
}

.spm1-org-image {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}
</style>
